// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import dataTableStyles from "@steiner/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { tableStyles } from "@steiner/Overrides/Widgets/InvoiceHistory/InvoiceHistoryTable";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { myAccountTableScrollbar, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

tableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};

tableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

tableStyles.totalHeader = {
    alignX: "left",
};

tableStyles.currentBalanceHeader = {
    alignX: "left",
};

tableStyles.totalCell = {
    alignX: "left",
};

tableStyles.currentBalanceCell = {
    alignX: "left",
};

tableStyles.shipToCell = {
    css: css`
        ${TypographyStyle} {
            text-wrap: wrap;
        }
    `,
};

tableStyles.shipToHeader = {
    css: css`
        min-width: 220px;
    `,
};

tableStyles.payLinkWrapper = {
    css: css`
        padding: 0 12px;
        ${xScreen("lte", "md")} {
            padding: 0;
        }
    `,
};

tableStyles.payLink = {
    typographyProps: {
        size: fontConfig.fontSize.xSmall,
        weight: fontConfig.weight.semiBold,
        lineHeight: fontConfig.lineHeight.xSmall,
    },
};

tableStyles.container = {
    css: css`
        ${myAccountTableScrollbar}
    `,
};
